import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from 'config/constants';
import RadioBtnTypeSetting from 'components/property-settings/radio-btn-type-setting/radio-btn-type-setting';
import { PropertyBox, PropertyLabel } from 'components/property-settings/property-shared-styles';
import { Box, Typography } from '@mui/material';

type TestingStepsProps = {
    handleSettings: (propertyName: string, settingValue: string) => void;
    testingSteps: string;
    options?: string[];
    isRequired?: boolean;
};

const TestingSteps: FC<TestingStepsProps> = ({
    handleSettings,
    testingSteps,
    options,
    isRequired,
}: TestingStepsProps) => {
    const { t: translate } = useTranslation(['construction-props']);

    return (
        <PropertyBox>
            <Box display="flex">
                <PropertyLabel variant="h5">{translate('TESTING_STEPS')}</PropertyLabel>
                {isRequired && (
                    <Typography
                        component="span"
                        color="error"
                        fontSize={18}
                        sx={{ marginLeft: '2px', marginTop: '-5px' }}
                    >
                        *
                    </Typography>
                )}
            </Box>
            <RadioBtnTypeSetting
                setting={options ? options : CONSTANTS.TESTING_STEPS}
                propertyName="testingSteps"
                settingValue={testingSteps?.split('TESTING_STEPS_')[1]}
                handlePropertySelection={handleSettings}
            />
        </PropertyBox>
    );
};

export default TestingSteps;
